/***
 *
 *   PROGRESS STEPS
 *   Phase 9 — reference signup ProgressIndicator pill chrome (tailwind).
 *
 *   PROPS
 *   items: array of { key?, name, url?, completed?, icon? }
 *   current: current step index (optional; inferred from first incomplete)
 *
 **********/

import { Link, Icon, cn } from 'components/lib';
import Style from './steps.tailwind.js';

export function ProgressSteps(props) {
    const items = Array.isArray(props.items)
        ? props.items
        : Object.values(props.items || {});

    const currentIndex =
        typeof props.current === 'number'
            ? props.current
            : Math.max(
                  0,
                  items.findIndex((item) => !item.completed),
              );

    return (
        <ol className={Style.row}>
            {items.map((item, i) => {
                const isActive = i === currentIndex;
                const isDone = item.completed || i < currentIndex;
                const distance = Math.abs(i - currentIndex);
                const flexValue = isActive ? 4 : distance === 1 ? 2 : 1;
                const opacity = isActive ? 1 : distance === 1 ? 0.65 : distance === 2 ? 0.42 : 0.2;

                const label = (
                    <>
                        {isDone && !isActive ? (
                            <Icon image="check" size={14} color="currentColor" className="shrink-0" />
                        ) : item.icon ? (
                            <Icon
                                image={item.icon}
                                size={isActive ? 16 : 14}
                                color="currentColor"
                                className="shrink-0"
                            />
                        ) : null}
                        <span className={cn(Style.label, isActive ? Style.labelActive : Style.labelIdle)}>
                            {item.name}
                        </span>
                    </>
                );

                return (
                    <li
                        key={item.key || item.name}
                        style={{ flex: flexValue, opacity }}
                        className={cn(
                            Style.chip,
                            isActive && Style.chipActive,
                            isDone && !isActive && Style.chipDone,
                            !isActive && !isDone && Style.chipIdle,
                        )}>
                        {item.url && !isActive ? (
                            <Link url={item.url} className={Style.link}>
                                {label}
                            </Link>
                        ) : (
                            label
                        )}
                    </li>
                );
            })}
        </ol>
    );
}
